// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-base/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-calendars/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@syncfusion/ej2-react-schedule/styles/material.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Time Line */
.calendarWrp .e-schedule .e-month-view .e-current-date .e-date-header,
.calendarWrp .e-schedule .e-month-agenda-view .e-current-date .e-date-header {
	background-color: var(--brand);
	aspect-ratio: 1 / 1;
	width: auto;
	max-width: max-content;
	min-width: 30px;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: auto;
}

.calendarWrp .e-schedule .e-month-view .e-date-header-wrap table td.e-current-day,
.calendarWrp .e-schedule .e-month-agenda-view .e-date-header-wrap table td.e-current-day {
	background-color: var(--brand);
	color: var(--white);
	font-weight: 700;
}

.calendarWrp .e-calendar .e-content.e-year td.e-selected:hover span.e-day,
.calendarWrp .e-calendar .e-content.e-year td.e-selected span.e-day {
	background-color: var(--brand);
}

.calendarWrp .e-btn.e-flat.e-primary,
.calendarWrp .e-css.e-btn.e-flat.e-primary {
	background-color: var(--brand);
	color: var(--white);
}

.calendarWrp .e-btn.e-flat.e-primary:hover,
.calendarWrp .e-css.e-btn.e-flat.e-primary:hover {
	background-color: var(--border);
	color: var(--brand);
}

.calendarWrp .e-schedule .e-vertical-view .e-header-cells.e-current-day {
	color: var(--brand);
	font-weight: 700;
}

.calendarWrp .e-schedule .e-vertical-view .e-current-timeline {
	border: 1px solid var(--brand);
}

.calendarWrp .e-schedule .e-vertical-view .e-previous-timeline {
	border: 1px dotted var(--brand);
}

.calendarWrp .e-schedule .e-vertical-view .e-clone-time-indicator,
.calendarWrp .e-schedule .e-vertical-view .e-current-time {
	color: var(--brand);
	font-weight: 700;
	font-size: 14px;
}

.calendarWrp .e-calendar .e-content td.e-today span.e-day,
.calendarWrp .e-calendar .e-content td.e-focused-date.e-today span.e-day {
	background-color: var(--brand);
	color: var(--white);
}

.calendarWrp .e-calendar .e-content td.e-today.e-selected:hover span.e-day,
.calendarWrp .e-calendar .e-content td.e-selected:hover span.e-day,
.calendarWrp .e-calendar .e-content td.e-selected.e-focused-date span.e-day {
	background: var(--brand);
}

.calendarWrp .e-calendar .e-content td.e-today:hover span.e-day,
.calendarWrp .e-calendar .e-content td.e-focused-date.e-today:hover span.e-day,
.calendarWrp .e-calendar .e-content td.e-today.e-selected span.e-day {
	border: 1px solid var(--brand);
}

.calendarWrp.commonCalendar .e-schedule .e-table-container {
	max-height: calc(100dvh - 30dvh) !important;
}

/* Time Line */

/* =========================
   Custom Syncfusion Scheduler
   ========================= */

.e-schedule.custom-scheduler,
.e-schedule.custom-scheduler * {
	box-sizing: border-box;
}

.e-schedule.custom-scheduler {
	padding: 0 !important;
}

.e-schedule.custom-scheduler .e-schedule-toolbar,
.e-schedule.custom-scheduler .e-toolbar {
	background: transparent !important;
	border: none !important;
	box-shadow: none !important;
	padding: 6px 8px !important;
	align-items: center;
	gap: 8px;
}

.e-schedule.custom-scheduler .e-toolbar .e-toolbar-item,
.e-schedule.custom-scheduler .e-toolbar .e-date-range,
.e-schedule.custom-scheduler .e-schedule-toolbar .e-date-range {
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.e-schedule.custom-scheduler .e-date-range,
.e-schedule.custom-scheduler .e-header-date {
	font-size: 15px !important;
	font-weight: 600 !important;
	color: #111827 !important;
}

.e-schedule.custom-scheduler .e-time-cells,
.e-schedule.custom-scheduler .e-time-label {
	color: #9ca3af !important;
	font-size: 12px !important;
	width: 70px !important;
	min-width: 70px !important;
}

.e-schedule.custom-scheduler .e-header-cells,
.e-schedule.custom-scheduler .e-resource-cells,
.e-schedule.custom-scheduler .e-date-header-wrap {
	border-color: var(--border) !important;
	background: #fff !important;
	color: #111827 !important;
	font-weight: 600 !important;
}

.e-schedule.custom-scheduler .e-work-cells,
.e-schedule.custom-scheduler .e-cell {
	border-color: var(--border) !important;
	transition: all 0.12s ease !important;
}

.e-schedule.custom-scheduler .e-work-cells:hover {
	background: #fbfdff !important;
}

.e-schedule.custom-scheduler .e-appointment,
.e-schedule.custom-scheduler .e-appointment-border {
	border-radius: 10px !important;
	padding: 6px 8px !important;
	font-size: 12px !important;
	font-weight: 500 !important;
	box-shadow: 0 2px 6px rgba(2, 6, 23, 0.06) !important;
	color: #111827 !important;
	border: 1px solid rgba(0, 0, 0, 0.06) !important;
	overflow: hidden !important;
}

.e-schedule.custom-scheduler .e-appointment .e-subject {
	display: block !important;
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	font-size: 12px !important;
	margin-bottom: 2px !important;
	color: black
}

.e-schedule.custom-scheduler .e-appointment .e-time {
	display: block !important;
	font-size: 11px !important;
	/* color: #4b5563 !important; */
	font-weight: 400 !important;
}

.e-schedule.custom-scheduler .e-appointment {
	filter: saturate(0.9) !important;
	opacity: 0.98 !important;
}

.e-schedule.custom-scheduler .e-quick-popup {
	border-radius: 10px !important;
	border: 1px solid var(--border) !important;
	box-shadow: 0 8px 24px rgba(2, 6, 23, 0.08) !important;
}

.e-schedule.custom-scheduler .e-agenda-view .e-subject {
	color: var(--accent) !important;
	font-weight: 600 !important;
}

.e-schedule.custom-scheduler ::-webkit-scrollbar {
	height: 8px;
	width: 8px;
}

.e-schedule.custom-scheduler ::-webkit-scrollbar-thumb {
	background: #d1d5db !important;
	border-radius: 6px;
}

.e-schedule.custom-scheduler ::-webkit-scrollbar-thumb:hover {
	background: #9ca3af !important;
}

.e-schedule.custom-scheduler .e-content-wrap {
	overflow-x: hidden !important;
}

.e-schedule.custom-scheduler .e-resource-cells .e-resource-text::before {
	content: '' !important;
	display: inline-block !important;
	width: 10px !important;
	height: 10px !important;
	border-radius: 6px !important;
	margin-right: 8px !important;
	vertical-align: middle !important;
	background: currentColor !important;
	/* fallback: uses color */
}

/* .e-schedule.custom-scheduler .e-appointment {
	background-color: #e6ffe9 !important;
	border-radius: unset !important;
} */

/* ----- event modal icon ----- */
.e-quick-popup-wrapper .e-event-popup .e-popup-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 5px;
	flex-direction: row-reverse;
}

.e-popup-header,
.e-schedule-dialog.e-device .e-dlg-header-content {
	background-color: var(--brand) !important;
}

.e-schedule-dialog.e-device .e-dlg-header-content {
	align-items: center !important;
}

.e-schedule-dialog.e-device .e-dlg-header-content {
	padding: 10px;
}

.e-schedule-dialog.e-device .e-title-header {
	align-items: center !important;
}

.e-schedule-dialog.e-device .e-icons,
.e-dialog .e-dlg-header-content .e-icons {
	filter: invert(1);
}

.e-quick-popup-wrapper .e-event-popup .e-popup-header .e-subject-wrap {
	padding: 0 10px !important;
}

.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open,
.e-quick-dialog {
	border-radius: 10px !important;
	overflow: hidden !important;
}

.e-quick-popup-wrapper .e-event-popup .e-popup-header .e-subject-wrap .e-subject,
.e-quick-dialog .e-dlg-header {
	font-size: 16px !important;
	font-family: var(--font-inter) !important;
	display: -webkit-box !important;
	-webkit-box-orient: vertical !important;
	-webkit-line-clamp: 2 !important;
	/* limit to 3 lines */
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	white-space: normal !important;
	/* allow line wrapping */
	word-wrap: break-word !important;
}

.e-quick-popup-wrapper .e-event-popup .e-popup-content {
	padding: 10px !important;
}

.event-detail-modal-wrp .e-subject {
	display: flex;
	gap: 12px;
	margin: 10px 0;
}

.event-detail-modal-wrp .e-subject img {
	width: 20px !important;
	height: 20px !important;
}

.event-detail-modal-wrp .e-subject h4 {
	font-size: 14px !important;
	font-family: var(--font-inter) !important;
	font-weight: 600 !important;
}

.e-dialog.e-quick-dialog .e-dlg-header-content {
	padding: 10px !important;
}

.e-schedule-dialog .e-popup.e-popup-open.e-dialog {
	display: inline-flex;
	border-radius: 15px;
	overflow: hidden;
}

.e-schedule-dialog .e-dlg-header-content,
.e-dialog .e-dlg-header-content {
	padding-bottom: 10px;
	background-color: var(--brand);
	margin-bottom: 10px;
}

.e-schedule-dialog .e-dlg-header-content .e-title-text,
.e-dialog .e-dlg-header-content .e-title-text,
.e-quick-dialog .e-dlg-header {
	color: #fff;
}

.e-dialog .e-dlg-content {
	padding: 18px !important;
	font-size: 14px !important;
	font-family: var(--font-inter) !important;
	max-height: 600px;
}

.e-schedule-dialog .e-textlabel,
.e-quick-popup-wrapper .e-textlabel {
	font-size: 14px !important;
	font-family: var(--font-inter) !important;
	font-weight: 500 !important;
	color: var(--brand) !important;
}

.e-schedule-dialog .custom-event-editor .e-input:focus,
.e-quick-popup-wrapper .e-input:focus {
	border-color: rgba(0, 0, 0, 0.42) !important;
}

.e-schedule-dialog .custom-event-editor .e-input-group::before,
.e-schedule-dialog .e-input-group::after {
	display: none !important;
}

.e-schedule-dialog .custom-event-editor .checkbox,
.e-quick-popup-wrapper .checkbox {
	width: auto !important;
	margin-left: 15px !important;
	cursor: pointer !important;
}

.e-schedule-dialog .e-btn.e-flat.e-primary,
.e-schedule-dialog .e-css.e-btn.e-flat.e-primary,
.e-schedule-dialog .e-btn.e-event-delete,
.e-quick-popup-wrapper .e-btn.e-flat.e-primary,
.e-quick-popup-wrapper .e-btn.e-event-delete,
.e-quick-popup-wrapper .e-css.e-btn.e-flat.e-primary,
.e-schedule-dialog .e-btn.e-event-cancel,
.e-quick-popup-wrapper .e-btn.e-primary,
.e-quick-popup-wrapper .e-btn.e-event-details,
.e-quick-dialog.e-quick-dialog-delete,
.e-quick-dialog.e-quick-dialog-cancel,
.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn,
.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn#kazoo-date {
	border-color: transparent !important;
	cursor: pointer !important;
	text-transform: capitalize !important;
	background-color: var(--brand) !important;
	border-radius: var(--border-radius) !important;
	padding: 8px 16px !important;
	font: var(--body-font-three) !important;
	font-weight: 500 !important;
	color: var(--white) !important;
	border: 1px solid transparent !important;
	letter-spacing: 0.3px !important;
	line-height: 1.3 !important;
	transition: all 0.2s ease-in-out;
}

.e-quick-popup-wrapper .e-btn.e-event-cancel,
.e-quick-popup-wrapper .e-btn.e-event-delete,
.e-schedule-dialog .e-btn.e-event-delete,
.e-quick-dialog.e-quick-dialog-delete {
	background-color: var(--error) !important;
	color: var(--white) !important;
}

.e-quick-popup-wrapper .e-btn.e-event-details,
.e-quick-dialog.e-quick-dialog-cancel,
.e-schedule-dialog .e-btn.e-event-cancel {
	background-color: var(--white) !important;
	color: var(--primary-Text) !important;
	border: 1px solid var(--border) !important;
}

.e-schedule-dialog .e-footer-content {
	display: flex !important;
	justify-content: end !important;
}

.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn {
	padding: 4px 8px !important;
}

.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn-text,
.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn#kazoo-date .e-tbar-btn-text {
	display: block !important;
	font: var(--body-font-three) !important;
	font-weight: 500 !important;
	color: var(--white) !important;
	text-transform: capitalize !important;
}

.e-schedule .e-schedule-toolbar .e-icon-add::before {
	color: var(--white) !important;
	font-size: 12px !important;
}

.e-schedule .e-month-view .e-appointment {
	height: auto !important;
}

/* Hide time and other details, show only title in event cells */
.e-schedule .e-appointment .e-appointment-details {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: 4px 8px;
}

.e-schedule .e-vertical-view .e-all-day-appointment-wrapper .e-appointment .e-appointment-details {
	height: auto !important;
}

/* Hide location if present */
.e-schedule .e-appointment .e-location {
	display: none !important;
}

/* Make subject/title take full space */
.e-schedule .e-appointment .e-subject {
	font-size: 13px;
	font-weight: 500;
	line-height: 1.3;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	white-space: normal;
	width: 100%;
}

/* Responsive adjustments for smaller screens */
.e-schedule .e-appointment {
	display: flex;
	align-items: center;
	justify-content: flex-start;
}

.e-schedule .e-all-day-appointment-wrapper .e-appointment .e-subject {
	-webkit-line-clamp: 1;
}

.e-schedule .e-month-view .e-appointment .e-subject {
	font-size: 12px;
	-webkit-line-clamp: 1;
}

.e-schedule .e-vertical-view .e-appointment .e-subject {
	-webkit-line-clamp: 3;
}

/* ===========================
   Color Picker Styling
   =========================== */

.color-picker-wrapper {
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 0;
}

.color-picker {
	width: 60px;
	height: 40px;
	border: 2px solid #ddd;
	border-radius: 6px;
	cursor: pointer;
	padding: 4px;
	background-color: white;
	transition: all 0.3s ease;
	margin: 0;
}

.color-picker:hover {
	border-color: var(--brand);
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
}

.color-picker:focus {
	outline: none;
	border-color: var(--brand);
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}

.color-preview {
	display: inline-block;
	width: 35px;
	height: 35px;
	border: 2px solid #ddd;
	border-radius: 6px;
	background-color: #3498db;
	transition: all 0.3s ease;
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
}

/* Event Cell with Custom Color - Dynamic from inline styles */
.e-event-content {
	border-radius: 8px !important;
	padding: 6px 8px !important;
	font-weight: 500 !important;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
	position: relative;
	overflow: hidden !important;
	transition: all 0.3s ease !important;
	display: flex !important;
	flex-direction: column !important;
	justify-content: center !important;
	min-height: 50px !important;
}

.e-event-content:hover {
	transform: translateY(-2px) !important;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}

.e-schedule.custom-scheduler .e-appointment {
	background: inherit !important;
	border: none !important;
	border-left: 4px solid inherit !important;
	color: inherit !important;
	filter: none !important;
	opacity: 1 !important;
	overflow: hidden !important;
}

.e-subject-inner {
	display: flex !important;
	flex-direction: column !important;
	gap: 4px !important;
	width: 100% !important;
}

.e-subject-text {
	font-size: 13px !important;
	font-weight: 600 !important;
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	line-height: 1.3 !important;
}

.e-time-text {
	font-size: 11px !important;
	font-weight: 400 !important;
	line-height: 1.2 !important;
}

/* Event Subject Inner Styling for Custom Colors */
.e-subject-inner {
	display: flex !important;
	flex-direction: column !important;
	gap: 4px !important;
	width: 100% !important;
}

.e-subject-text {
	font-size: 13px !important;
	font-weight: 600 !important;
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	color: inherit !important;
}

.e-time-text {
	font-size: 11px !important;
	opacity: 0.85 !important;
	color: inherit !important;
}

/* Quick Info Template with Color Border */
.event-detail-modal-wrp .e-subject-wrap {
	background-color: #f9f9f9;
	border-radius: 4px;
	margin: 8px 0;
	padding: 12px;
}

/* Editor Template Form Styling */
.custom-event-editor table {
	width: 100%;
	border-collapse: collapse;
}

.custom-event-editor td {
	padding: 12px 8px;
	vertical-align: top;
}

.custom-event-editor .e-textlabel {
	font-weight: 500;
	color: var(--brand);
	white-space: nowrap;
	padding-right: 15px;
}

.custom-event-editor .e-input,
.custom-event-editor input[type='text'],
.custom-event-editor input[type='number'],
.custom-event-editor textarea {
	width: 100%;
	padding: 8px 10px;
	border: 1px solid #ddd;
	border-radius: 6px;
	font-family: var(--font-inter,
			-apple-system,
			BlinkMacSystemFont,
			'Segoe UI',
			sans-serif);
	font-size: 14px;
	transition: border-color 0.3s ease;
}

.custom-event-editor input[type='text']:focus,
.custom-event-editor input[type='number']:focus,
.custom-event-editor textarea:focus {
	outline: none;
	border-color: var(--brand);
	box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

/* For multiselect input field (hides the border if its not selected)*/
.e-searcher.e-zero-size input {
	border: none;
}

/* Responsive Adjustments */
@media screen and (max-width: 768px) {
	.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn-text {
		display: none !important;
	}

	.e-schedule .e-vertical-view .e-appointment .e-subject {
		-webkit-line-clamp: 2;
	}

	.e-schedule .e-appointment .e-subject {
		font-size: 12px;
		-webkit-line-clamp: 2;
	}

	.e-schedule .e-appointment .e-appointment-details {
		padding: 3px 6px;
	}

	.color-picker {
		width: 50px;
		height: 35px;
	}

	.color-preview {
		width: 30px;
		height: 30px;
	}

	.custom-event-editor td {
		padding: 10px 6px;
	}
}

@media screen and (max-width: 480px) {
	.e-schedule .e-appointment .e-subject {
		font-size: 11px;
		-webkit-line-clamp: 1;
	}

	.e-schedule .e-appointment .e-appointment-details {
		padding: 2px 4px;
	}

	.color-picker {
		width: 45px;
		height: 32px;
	}

	.color-preview {
		width: 25px;
		height: 25px;
	}

	.color-picker-wrapper {
		gap: 8px;
	}

	.custom-event-editor td {
		padding: 8px 4px;
	}

	.custom-event-editor .e-textlabel {
		font-size: 12px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/scheduler/scheduler.css"],"names":[],"mappings":"AAWA,cAAc;AACd;;CAEC,8BAA8B;CAC9B,mBAAmB;CACnB,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;AACb;;AAEA;;CAEC,8BAA8B;CAC9B,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;;CAEC,+BAA+B;CAC/B,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;CAEC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;;;CAGC,wBAAwB;AACzB;;AAEA;;;CAGC,8BAA8B;AAC/B;;AAEA;CACC,2CAA2C;AAC5C;;AAEA,cAAc;;AAEd;;8BAE8B;;AAE9B;;CAEC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,kCAAkC;CAClC,uBAAuB;CACvB,2BAA2B;CAC3B,2BAA2B;CAC3B,mBAAmB;CACnB,QAAQ;AACT;;AAEA;;;CAGC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;;CAEC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,0BAA0B;CAC1B,sBAAsB;CACtB,0BAA0B;AAC3B;;AAEA;;;CAGC,sCAAsC;CACtC,2BAA2B;CAC3B,yBAAyB;CACzB,2BAA2B;AAC5B;;AAEA;;CAEC,sCAAsC;CACtC,qCAAqC;AACtC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,2BAA2B;CAC3B,0BAA0B;CAC1B,2BAA2B;CAC3B,qDAAqD;CACrD,yBAAyB;CACzB,gDAAgD;CAChD,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,8BAA8B;CAC9B,2BAA2B;CAC3B,kCAAkC;CAClC,0BAA0B;CAC1B,6BAA6B;CAC7B;AACD;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,+BAA+B;CAC/B,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;CAChC,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;CAC9B,0CAA0C;CAC1C,sDAAsD;AACvD;;AAEA;CACC,+BAA+B;CAC/B,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,gCAAgC;CAChC,sBAAsB;CACtB,uBAAuB;CACvB,6BAA6B;CAC7B,4BAA4B;CAC5B,iCAAiC;CACjC,mCAAmC;CACnC,yBAAyB;AAC1B;;AAEA;;;GAGG;;AAEH,iCAAiC;AACjC;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;;CAEC,yCAAyC;AAC1C;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;;CAEC,0BAA0B;CAC1B,yCAAyC;CACzC,+BAA+B;CAC/B,uCAAuC;CACvC,gCAAgC;CAChC,qBAAqB;CACrB,2BAA2B;CAC3B,kCAAkC;CAClC,8BAA8B;CAC9B,wBAAwB;CACxB,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,0BAA0B;CAC1B,yCAAyC;CACzC,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,oBAAoB;CACpB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC,wBAAwB;CACxB,0BAA0B;CAC1B,yCAAyC;CACzC,iBAAiB;AAClB;;AAEA;;CAEC,0BAA0B;CAC1B,yCAAyC;CACzC,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;;CAEC,4CAA4C;AAC7C;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;;CAEC,sBAAsB;CACtB,4BAA4B;CAC5B,0BAA0B;AAC3B;;AAEA;;;;;;;;;;;;;CAaC,oCAAoC;CACpC,0BAA0B;CAC1B,qCAAqC;CACrC,yCAAyC;CACzC,8CAA8C;CAC9C,4BAA4B;CAC5B,uCAAuC;CACvC,2BAA2B;CAC3B,8BAA8B;CAC9B,wCAAwC;CACxC,gCAAgC;CAChC,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;;;;CAIC,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;;;CAGC,yCAAyC;CACzC,qCAAqC;CACrC,0CAA0C;AAC3C;;AAEA;CACC,wBAAwB;CACxB,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;;CAEC,yBAAyB;CACzB,uCAAuC;CACvC,2BAA2B;CAC3B,8BAA8B;CAC9B,qCAAqC;AACtC;;AAEA;CACC,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;AACxB;;AAEA,gEAAgE;AAChE;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA,6BAA6B;AAC7B;CACC,wBAAwB;AACzB;;AAEA,uCAAuC;AACvC;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;CACpB,qBAAqB;CACrB,4BAA4B;CAC5B,mBAAmB;CACnB,WAAW;AACZ;;AAEA,+CAA+C;AAC/C;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;gCAEgC;;AAEhC;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,0BAA0B;CAC1B,uCAAuC;AACxC;;AAEA;CACC,aAAa;CACb,0BAA0B;CAC1B,sCAAsC;AACvC;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;CACzB,yBAAyB;CACzB,8CAA8C;AAC/C;;AAEA,8DAA8D;AAC9D;CACC,6BAA6B;CAC7B,2BAA2B;CAC3B,2BAA2B;CAC3B,oDAAoD;CACpD,kBAAkB;CAClB,2BAA2B;CAC3B,oCAAoC;CACpC,wBAAwB;CACxB,iCAAiC;CACjC,kCAAkC;CAClC,2BAA2B;AAC5B;;AAEA;CACC,sCAAsC;CACtC,oDAAoD;AACrD;;AAEA;CACC,8BAA8B;CAC9B,uBAAuB;CACvB,yCAAyC;CACzC,yBAAyB;CACzB,uBAAuB;CACvB,qBAAqB;CACrB,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;CACxB,iCAAiC;CACjC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,8BAA8B;CAC9B,2BAA2B;CAC3B,kCAAkC;CAClC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,2BAA2B;AAC5B;;AAEA,kDAAkD;AAClD;CACC,wBAAwB;CACxB,iCAAiC;CACjC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,8BAA8B;CAC9B,2BAA2B;CAC3B,kCAAkC;CAClC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,wBAAwB;CACxB,yBAAyB;AAC1B;;AAEA,0CAA0C;AAC1C;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,aAAa;AACd;;AAEA,iCAAiC;AACjC;CACC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;;;;CAIC,WAAW;CACX,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB;;;;cAIa;CACb,eAAe;CACf,kCAAkC;AACnC;;AAEA;;;CAGC,aAAa;CACb,0BAA0B;CAC1B,6CAA6C;AAC9C;;AAEA,sEAAsE;AACtE;CACC,YAAY;AACb;;AAEA,2BAA2B;AAC3B;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":["@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-lists/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';\r\n@import '../../../node_modules/@syncfusion/ej2-react-schedule/styles/material.css';\r\n\r\n/* Time Line */\r\n.calendarWrp .e-schedule .e-month-view .e-current-date .e-date-header,\r\n.calendarWrp .e-schedule .e-month-agenda-view .e-current-date .e-date-header {\r\n\tbackground-color: var(--brand);\r\n\taspect-ratio: 1 / 1;\r\n\twidth: auto;\r\n\tmax-width: max-content;\r\n\tmin-width: 30px;\r\n\tpadding: 0;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\theight: auto;\r\n}\r\n\r\n.calendarWrp .e-schedule .e-month-view .e-date-header-wrap table td.e-current-day,\r\n.calendarWrp .e-schedule .e-month-agenda-view .e-date-header-wrap table td.e-current-day {\r\n\tbackground-color: var(--brand);\r\n\tcolor: var(--white);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.calendarWrp .e-calendar .e-content.e-year td.e-selected:hover span.e-day,\r\n.calendarWrp .e-calendar .e-content.e-year td.e-selected span.e-day {\r\n\tbackground-color: var(--brand);\r\n}\r\n\r\n.calendarWrp .e-btn.e-flat.e-primary,\r\n.calendarWrp .e-css.e-btn.e-flat.e-primary {\r\n\tbackground-color: var(--brand);\r\n\tcolor: var(--white);\r\n}\r\n\r\n.calendarWrp .e-btn.e-flat.e-primary:hover,\r\n.calendarWrp .e-css.e-btn.e-flat.e-primary:hover {\r\n\tbackground-color: var(--border);\r\n\tcolor: var(--brand);\r\n}\r\n\r\n.calendarWrp .e-schedule .e-vertical-view .e-header-cells.e-current-day {\r\n\tcolor: var(--brand);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.calendarWrp .e-schedule .e-vertical-view .e-current-timeline {\r\n\tborder: 1px solid var(--brand);\r\n}\r\n\r\n.calendarWrp .e-schedule .e-vertical-view .e-previous-timeline {\r\n\tborder: 1px dotted var(--brand);\r\n}\r\n\r\n.calendarWrp .e-schedule .e-vertical-view .e-clone-time-indicator,\r\n.calendarWrp .e-schedule .e-vertical-view .e-current-time {\r\n\tcolor: var(--brand);\r\n\tfont-weight: 700;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.calendarWrp .e-calendar .e-content td.e-today span.e-day,\r\n.calendarWrp .e-calendar .e-content td.e-focused-date.e-today span.e-day {\r\n\tbackground-color: var(--brand);\r\n\tcolor: var(--white);\r\n}\r\n\r\n.calendarWrp .e-calendar .e-content td.e-today.e-selected:hover span.e-day,\r\n.calendarWrp .e-calendar .e-content td.e-selected:hover span.e-day,\r\n.calendarWrp .e-calendar .e-content td.e-selected.e-focused-date span.e-day {\r\n\tbackground: var(--brand);\r\n}\r\n\r\n.calendarWrp .e-calendar .e-content td.e-today:hover span.e-day,\r\n.calendarWrp .e-calendar .e-content td.e-focused-date.e-today:hover span.e-day,\r\n.calendarWrp .e-calendar .e-content td.e-today.e-selected span.e-day {\r\n\tborder: 1px solid var(--brand);\r\n}\r\n\r\n.calendarWrp.commonCalendar .e-schedule .e-table-container {\r\n\tmax-height: calc(100dvh - 30dvh) !important;\r\n}\r\n\r\n/* Time Line */\r\n\r\n/* =========================\r\n   Custom Syncfusion Scheduler\r\n   ========================= */\r\n\r\n.e-schedule.custom-scheduler,\r\n.e-schedule.custom-scheduler * {\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.e-schedule.custom-scheduler {\r\n\tpadding: 0 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-schedule-toolbar,\r\n.e-schedule.custom-scheduler .e-toolbar {\r\n\tbackground: transparent !important;\r\n\tborder: none !important;\r\n\tbox-shadow: none !important;\r\n\tpadding: 6px 8px !important;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-toolbar .e-toolbar-item,\r\n.e-schedule.custom-scheduler .e-toolbar .e-date-range,\r\n.e-schedule.custom-scheduler .e-schedule-toolbar .e-date-range {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-date-range,\r\n.e-schedule.custom-scheduler .e-header-date {\r\n\tfont-size: 15px !important;\r\n\tfont-weight: 600 !important;\r\n\tcolor: #111827 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-time-cells,\r\n.e-schedule.custom-scheduler .e-time-label {\r\n\tcolor: #9ca3af !important;\r\n\tfont-size: 12px !important;\r\n\twidth: 70px !important;\r\n\tmin-width: 70px !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-header-cells,\r\n.e-schedule.custom-scheduler .e-resource-cells,\r\n.e-schedule.custom-scheduler .e-date-header-wrap {\r\n\tborder-color: var(--border) !important;\r\n\tbackground: #fff !important;\r\n\tcolor: #111827 !important;\r\n\tfont-weight: 600 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-work-cells,\r\n.e-schedule.custom-scheduler .e-cell {\r\n\tborder-color: var(--border) !important;\r\n\ttransition: all 0.12s ease !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-work-cells:hover {\r\n\tbackground: #fbfdff !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-appointment,\r\n.e-schedule.custom-scheduler .e-appointment-border {\r\n\tborder-radius: 10px !important;\r\n\tpadding: 6px 8px !important;\r\n\tfont-size: 12px !important;\r\n\tfont-weight: 500 !important;\r\n\tbox-shadow: 0 2px 6px rgba(2, 6, 23, 0.06) !important;\r\n\tcolor: #111827 !important;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.06) !important;\r\n\toverflow: hidden !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-appointment .e-subject {\r\n\tdisplay: block !important;\r\n\twhite-space: nowrap !important;\r\n\toverflow: hidden !important;\r\n\ttext-overflow: ellipsis !important;\r\n\tfont-size: 12px !important;\r\n\tmargin-bottom: 2px !important;\r\n\tcolor: black\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-appointment .e-time {\r\n\tdisplay: block !important;\r\n\tfont-size: 11px !important;\r\n\t/* color: #4b5563 !important; */\r\n\tfont-weight: 400 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-appointment {\r\n\tfilter: saturate(0.9) !important;\r\n\topacity: 0.98 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-quick-popup {\r\n\tborder-radius: 10px !important;\r\n\tborder: 1px solid var(--border) !important;\r\n\tbox-shadow: 0 8px 24px rgba(2, 6, 23, 0.08) !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-agenda-view .e-subject {\r\n\tcolor: var(--accent) !important;\r\n\tfont-weight: 600 !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler ::-webkit-scrollbar {\r\n\theight: 8px;\r\n\twidth: 8px;\r\n}\r\n\r\n.e-schedule.custom-scheduler ::-webkit-scrollbar-thumb {\r\n\tbackground: #d1d5db !important;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.e-schedule.custom-scheduler ::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #9ca3af !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-content-wrap {\r\n\toverflow-x: hidden !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-resource-cells .e-resource-text::before {\r\n\tcontent: '' !important;\r\n\tdisplay: inline-block !important;\r\n\twidth: 10px !important;\r\n\theight: 10px !important;\r\n\tborder-radius: 6px !important;\r\n\tmargin-right: 8px !important;\r\n\tvertical-align: middle !important;\r\n\tbackground: currentColor !important;\r\n\t/* fallback: uses color */\r\n}\r\n\r\n/* .e-schedule.custom-scheduler .e-appointment {\r\n\tbackground-color: #e6ffe9 !important;\r\n\tborder-radius: unset !important;\r\n} */\r\n\r\n/* ----- event modal icon ----- */\r\n.e-quick-popup-wrapper .e-event-popup .e-popup-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 5px;\r\n\tflex-direction: row-reverse;\r\n}\r\n\r\n.e-popup-header,\r\n.e-schedule-dialog.e-device .e-dlg-header-content {\r\n\tbackground-color: var(--brand) !important;\r\n}\r\n\r\n.e-schedule-dialog.e-device .e-dlg-header-content {\r\n\talign-items: center !important;\r\n}\r\n\r\n.e-schedule-dialog.e-device .e-dlg-header-content {\r\n\tpadding: 10px;\r\n}\r\n\r\n.e-schedule-dialog.e-device .e-title-header {\r\n\talign-items: center !important;\r\n}\r\n\r\n.e-schedule-dialog.e-device .e-icons,\r\n.e-dialog .e-dlg-header-content .e-icons {\r\n\tfilter: invert(1);\r\n}\r\n\r\n.e-quick-popup-wrapper .e-event-popup .e-popup-header .e-subject-wrap {\r\n\tpadding: 0 10px !important;\r\n}\r\n\r\n.e-quick-popup-wrapper.e-lib.e-popup.e-control.e-popup-open,\r\n.e-quick-dialog {\r\n\tborder-radius: 10px !important;\r\n\toverflow: hidden !important;\r\n}\r\n\r\n.e-quick-popup-wrapper .e-event-popup .e-popup-header .e-subject-wrap .e-subject,\r\n.e-quick-dialog .e-dlg-header {\r\n\tfont-size: 16px !important;\r\n\tfont-family: var(--font-inter) !important;\r\n\tdisplay: -webkit-box !important;\r\n\t-webkit-box-orient: vertical !important;\r\n\t-webkit-line-clamp: 2 !important;\r\n\t/* limit to 3 lines */\r\n\toverflow: hidden !important;\r\n\ttext-overflow: ellipsis !important;\r\n\twhite-space: normal !important;\r\n\t/* allow line wrapping */\r\n\tword-wrap: break-word !important;\r\n}\r\n\r\n.e-quick-popup-wrapper .e-event-popup .e-popup-content {\r\n\tpadding: 10px !important;\r\n}\r\n\r\n.event-detail-modal-wrp .e-subject {\r\n\tdisplay: flex;\r\n\tgap: 12px;\r\n\tmargin: 10px 0;\r\n}\r\n\r\n.event-detail-modal-wrp .e-subject img {\r\n\twidth: 20px !important;\r\n\theight: 20px !important;\r\n}\r\n\r\n.event-detail-modal-wrp .e-subject h4 {\r\n\tfont-size: 14px !important;\r\n\tfont-family: var(--font-inter) !important;\r\n\tfont-weight: 600 !important;\r\n}\r\n\r\n.e-dialog.e-quick-dialog .e-dlg-header-content {\r\n\tpadding: 10px !important;\r\n}\r\n\r\n.e-schedule-dialog .e-popup.e-popup-open.e-dialog {\r\n\tdisplay: inline-flex;\r\n\tborder-radius: 15px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.e-schedule-dialog .e-dlg-header-content,\r\n.e-dialog .e-dlg-header-content {\r\n\tpadding-bottom: 10px;\r\n\tbackground-color: var(--brand);\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.e-schedule-dialog .e-dlg-header-content .e-title-text,\r\n.e-dialog .e-dlg-header-content .e-title-text,\r\n.e-quick-dialog .e-dlg-header {\r\n\tcolor: #fff;\r\n}\r\n\r\n.e-dialog .e-dlg-content {\r\n\tpadding: 18px !important;\r\n\tfont-size: 14px !important;\r\n\tfont-family: var(--font-inter) !important;\r\n\tmax-height: 600px;\r\n}\r\n\r\n.e-schedule-dialog .e-textlabel,\r\n.e-quick-popup-wrapper .e-textlabel {\r\n\tfont-size: 14px !important;\r\n\tfont-family: var(--font-inter) !important;\r\n\tfont-weight: 500 !important;\r\n\tcolor: var(--brand) !important;\r\n}\r\n\r\n.e-schedule-dialog .custom-event-editor .e-input:focus,\r\n.e-quick-popup-wrapper .e-input:focus {\r\n\tborder-color: rgba(0, 0, 0, 0.42) !important;\r\n}\r\n\r\n.e-schedule-dialog .custom-event-editor .e-input-group::before,\r\n.e-schedule-dialog .e-input-group::after {\r\n\tdisplay: none !important;\r\n}\r\n\r\n.e-schedule-dialog .custom-event-editor .checkbox,\r\n.e-quick-popup-wrapper .checkbox {\r\n\twidth: auto !important;\r\n\tmargin-left: 15px !important;\r\n\tcursor: pointer !important;\r\n}\r\n\r\n.e-schedule-dialog .e-btn.e-flat.e-primary,\r\n.e-schedule-dialog .e-css.e-btn.e-flat.e-primary,\r\n.e-schedule-dialog .e-btn.e-event-delete,\r\n.e-quick-popup-wrapper .e-btn.e-flat.e-primary,\r\n.e-quick-popup-wrapper .e-btn.e-event-delete,\r\n.e-quick-popup-wrapper .e-css.e-btn.e-flat.e-primary,\r\n.e-schedule-dialog .e-btn.e-event-cancel,\r\n.e-quick-popup-wrapper .e-btn.e-primary,\r\n.e-quick-popup-wrapper .e-btn.e-event-details,\r\n.e-quick-dialog.e-quick-dialog-delete,\r\n.e-quick-dialog.e-quick-dialog-cancel,\r\n.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn,\r\n.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn#kazoo-date {\r\n\tborder-color: transparent !important;\r\n\tcursor: pointer !important;\r\n\ttext-transform: capitalize !important;\r\n\tbackground-color: var(--brand) !important;\r\n\tborder-radius: var(--border-radius) !important;\r\n\tpadding: 8px 16px !important;\r\n\tfont: var(--body-font-three) !important;\r\n\tfont-weight: 500 !important;\r\n\tcolor: var(--white) !important;\r\n\tborder: 1px solid transparent !important;\r\n\tletter-spacing: 0.3px !important;\r\n\tline-height: 1.3 !important;\r\n\ttransition: all 0.2s ease-in-out;\r\n}\r\n\r\n.e-quick-popup-wrapper .e-btn.e-event-cancel,\r\n.e-quick-popup-wrapper .e-btn.e-event-delete,\r\n.e-schedule-dialog .e-btn.e-event-delete,\r\n.e-quick-dialog.e-quick-dialog-delete {\r\n\tbackground-color: var(--error) !important;\r\n\tcolor: var(--white) !important;\r\n}\r\n\r\n.e-quick-popup-wrapper .e-btn.e-event-details,\r\n.e-quick-dialog.e-quick-dialog-cancel,\r\n.e-schedule-dialog .e-btn.e-event-cancel {\r\n\tbackground-color: var(--white) !important;\r\n\tcolor: var(--primary-Text) !important;\r\n\tborder: 1px solid var(--border) !important;\r\n}\r\n\r\n.e-schedule-dialog .e-footer-content {\r\n\tdisplay: flex !important;\r\n\tjustify-content: end !important;\r\n}\r\n\r\n.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn {\r\n\tpadding: 4px 8px !important;\r\n}\r\n\r\n.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn-text,\r\n.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn#kazoo-date .e-tbar-btn-text {\r\n\tdisplay: block !important;\r\n\tfont: var(--body-font-three) !important;\r\n\tfont-weight: 500 !important;\r\n\tcolor: var(--white) !important;\r\n\ttext-transform: capitalize !important;\r\n}\r\n\r\n.e-schedule .e-schedule-toolbar .e-icon-add::before {\r\n\tcolor: var(--white) !important;\r\n\tfont-size: 12px !important;\r\n}\r\n\r\n.e-schedule .e-month-view .e-appointment {\r\n\theight: auto !important;\r\n}\r\n\r\n/* Hide time and other details, show only title in event cells */\r\n.e-schedule .e-appointment .e-appointment-details {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\tpadding: 4px 8px;\r\n}\r\n\r\n.e-schedule .e-vertical-view .e-all-day-appointment-wrapper .e-appointment .e-appointment-details {\r\n\theight: auto !important;\r\n}\r\n\r\n/* Hide location if present */\r\n.e-schedule .e-appointment .e-location {\r\n\tdisplay: none !important;\r\n}\r\n\r\n/* Make subject/title take full space */\r\n.e-schedule .e-appointment .e-subject {\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n\tline-height: 1.3;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\tdisplay: -webkit-box;\r\n\t-webkit-line-clamp: 2;\r\n\t-webkit-box-orient: vertical;\r\n\twhite-space: normal;\r\n\twidth: 100%;\r\n}\r\n\r\n/* Responsive adjustments for smaller screens */\r\n.e-schedule .e-appointment {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.e-schedule .e-all-day-appointment-wrapper .e-appointment .e-subject {\r\n\t-webkit-line-clamp: 1;\r\n}\r\n\r\n.e-schedule .e-month-view .e-appointment .e-subject {\r\n\tfont-size: 12px;\r\n\t-webkit-line-clamp: 1;\r\n}\r\n\r\n.e-schedule .e-vertical-view .e-appointment .e-subject {\r\n\t-webkit-line-clamp: 3;\r\n}\r\n\r\n/* ===========================\r\n   Color Picker Styling\r\n   =========================== */\r\n\r\n.color-picker-wrapper {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n\tmargin: 0;\r\n}\r\n\r\n.color-picker {\r\n\twidth: 60px;\r\n\theight: 40px;\r\n\tborder: 2px solid #ddd;\r\n\tborder-radius: 6px;\r\n\tcursor: pointer;\r\n\tpadding: 4px;\r\n\tbackground-color: white;\r\n\ttransition: all 0.3s ease;\r\n\tmargin: 0;\r\n}\r\n\r\n.color-picker:hover {\r\n\tborder-color: var(--brand);\r\n\tbox-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.color-picker:focus {\r\n\toutline: none;\r\n\tborder-color: var(--brand);\r\n\tbox-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.color-preview {\r\n\tdisplay: inline-block;\r\n\twidth: 35px;\r\n\theight: 35px;\r\n\tborder: 2px solid #ddd;\r\n\tborder-radius: 6px;\r\n\tbackground-color: #3498db;\r\n\ttransition: all 0.3s ease;\r\n\tbox-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Event Cell with Custom Color - Dynamic from inline styles */\r\n.e-event-content {\r\n\tborder-radius: 8px !important;\r\n\tpadding: 6px 8px !important;\r\n\tfont-weight: 500 !important;\r\n\tbox-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;\r\n\tposition: relative;\r\n\toverflow: hidden !important;\r\n\ttransition: all 0.3s ease !important;\r\n\tdisplay: flex !important;\r\n\tflex-direction: column !important;\r\n\tjustify-content: center !important;\r\n\tmin-height: 50px !important;\r\n}\r\n\r\n.e-event-content:hover {\r\n\ttransform: translateY(-2px) !important;\r\n\tbox-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;\r\n}\r\n\r\n.e-schedule.custom-scheduler .e-appointment {\r\n\tbackground: inherit !important;\r\n\tborder: none !important;\r\n\tborder-left: 4px solid inherit !important;\r\n\tcolor: inherit !important;\r\n\tfilter: none !important;\r\n\topacity: 1 !important;\r\n\toverflow: hidden !important;\r\n}\r\n\r\n.e-subject-inner {\r\n\tdisplay: flex !important;\r\n\tflex-direction: column !important;\r\n\tgap: 4px !important;\r\n\twidth: 100% !important;\r\n}\r\n\r\n.e-subject-text {\r\n\tfont-size: 13px !important;\r\n\tfont-weight: 600 !important;\r\n\twhite-space: nowrap !important;\r\n\toverflow: hidden !important;\r\n\ttext-overflow: ellipsis !important;\r\n\tline-height: 1.3 !important;\r\n}\r\n\r\n.e-time-text {\r\n\tfont-size: 11px !important;\r\n\tfont-weight: 400 !important;\r\n\tline-height: 1.2 !important;\r\n}\r\n\r\n/* Event Subject Inner Styling for Custom Colors */\r\n.e-subject-inner {\r\n\tdisplay: flex !important;\r\n\tflex-direction: column !important;\r\n\tgap: 4px !important;\r\n\twidth: 100% !important;\r\n}\r\n\r\n.e-subject-text {\r\n\tfont-size: 13px !important;\r\n\tfont-weight: 600 !important;\r\n\twhite-space: nowrap !important;\r\n\toverflow: hidden !important;\r\n\ttext-overflow: ellipsis !important;\r\n\tcolor: inherit !important;\r\n}\r\n\r\n.e-time-text {\r\n\tfont-size: 11px !important;\r\n\topacity: 0.85 !important;\r\n\tcolor: inherit !important;\r\n}\r\n\r\n/* Quick Info Template with Color Border */\r\n.event-detail-modal-wrp .e-subject-wrap {\r\n\tbackground-color: #f9f9f9;\r\n\tborder-radius: 4px;\r\n\tmargin: 8px 0;\r\n\tpadding: 12px;\r\n}\r\n\r\n/* Editor Template Form Styling */\r\n.custom-event-editor table {\r\n\twidth: 100%;\r\n\tborder-collapse: collapse;\r\n}\r\n\r\n.custom-event-editor td {\r\n\tpadding: 12px 8px;\r\n\tvertical-align: top;\r\n}\r\n\r\n.custom-event-editor .e-textlabel {\r\n\tfont-weight: 500;\r\n\tcolor: var(--brand);\r\n\twhite-space: nowrap;\r\n\tpadding-right: 15px;\r\n}\r\n\r\n.custom-event-editor .e-input,\r\n.custom-event-editor input[type='text'],\r\n.custom-event-editor input[type='number'],\r\n.custom-event-editor textarea {\r\n\twidth: 100%;\r\n\tpadding: 8px 10px;\r\n\tborder: 1px solid #ddd;\r\n\tborder-radius: 6px;\r\n\tfont-family: var(--font-inter,\r\n\t\t\t-apple-system,\r\n\t\t\tBlinkMacSystemFont,\r\n\t\t\t'Segoe UI',\r\n\t\t\tsans-serif);\r\n\tfont-size: 14px;\r\n\ttransition: border-color 0.3s ease;\r\n}\r\n\r\n.custom-event-editor input[type='text']:focus,\r\n.custom-event-editor input[type='number']:focus,\r\n.custom-event-editor textarea:focus {\r\n\toutline: none;\r\n\tborder-color: var(--brand);\r\n\tbox-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\r\n}\r\n\r\n/* For multiselect input field (hides the border if its not selected)*/\r\n.e-searcher.e-zero-size input {\r\n\tborder: none;\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media screen and (max-width: 768px) {\r\n\t.e-schedule .e-schedule-toolbar .e-toolbar-items .e-toolbar-item.e-add .e-tbar-btn-text {\r\n\t\tdisplay: none !important;\r\n\t}\r\n\r\n\t.e-schedule .e-vertical-view .e-appointment .e-subject {\r\n\t\t-webkit-line-clamp: 2;\r\n\t}\r\n\r\n\t.e-schedule .e-appointment .e-subject {\r\n\t\tfont-size: 12px;\r\n\t\t-webkit-line-clamp: 2;\r\n\t}\r\n\r\n\t.e-schedule .e-appointment .e-appointment-details {\r\n\t\tpadding: 3px 6px;\r\n\t}\r\n\r\n\t.color-picker {\r\n\t\twidth: 50px;\r\n\t\theight: 35px;\r\n\t}\r\n\r\n\t.color-preview {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t}\r\n\r\n\t.custom-event-editor td {\r\n\t\tpadding: 10px 6px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n\t.e-schedule .e-appointment .e-subject {\r\n\t\tfont-size: 11px;\r\n\t\t-webkit-line-clamp: 1;\r\n\t}\r\n\r\n\t.e-schedule .e-appointment .e-appointment-details {\r\n\t\tpadding: 2px 4px;\r\n\t}\r\n\r\n\t.color-picker {\r\n\t\twidth: 45px;\r\n\t\theight: 32px;\r\n\t}\r\n\r\n\t.color-preview {\r\n\t\twidth: 25px;\r\n\t\theight: 25px;\r\n\t}\r\n\r\n\t.color-picker-wrapper {\r\n\t\tgap: 8px;\r\n\t}\r\n\r\n\t.custom-event-editor td {\r\n\t\tpadding: 8px 4px;\r\n\t}\r\n\r\n\t.custom-event-editor .e-textlabel {\r\n\t\tfont-size: 12px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
